import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../../util/theme';

// import base styled components
import { Input } from '../../styled';

const CtaBarInput = styled(Input)`
  color: ${getColor('white')};

  &:hover,
  &:focus {
    border-bottom: 3px solid ${getColor('accentGreen')};
  }

  &:focus,
  &:valid {
    ~ label {
      color: ${getColor('white')};
    }
  }
`;

export default CtaBarInput;
